import * as React from 'react';
import createSvgIcon from '../utils/createSvgIcon';

const Recycle = createSvgIcon(
  <path d="M16.1,6L12,0L7.9,6.7l1.9,1.2l2.3-3.8l2,3L12,8.3l6,3l0.8-6.8L16.1,6z M7.9,9L9,15.8l-2.8-1.4l-2.4,4.4h4.5V21H0l4.2-7.6L1.5,12L7.9,9z M24,21l-4.3-8.6l-2,1l2.7,5.4h-4.6v-3l-5.3,4l5.2,4.1v-3H24V21z" />,
  'Recycle'
);

export { Recycle };